import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ReturnPolicyModal.css';

function ReturnPolicyModal({ onClose }) {
  const navigate = useNavigate();

  const handleContactClick = () => {
    onClose();
    navigate('/contact');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="policy-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>

        <h2>Return Policy</h2>
        <p className="policy-updated">Last updated: February 15, 2026</p>

        <p className="policy-intro">
          Thank you for shopping with us. Please review our policy carefully before making a purchase.
        </p>

        <div className="policy-section">
          <h3>All Sales Are Final</h3>
          <p>
            All orders are final. We do not offer refunds, returns, or exchanges unless an item is received defective or damaged.
          </p>
        </div>

        <div className="policy-section">
          <h3>Defective or Damaged Items</h3>
          <p>
            If you receive a defective or damaged product, you must notify us within <strong>7 days</strong> of delivery.
          </p>
          <p>
            To submit a claim, please contact us at{' '}
            <a href="mailto:sambasenergyllc@gmail.com" className="policy-link">
              sambasenergyllc@gmail.com
            </a>{' '}
            with:
          </p>
          <ul>
            <li>Your order number</li>
            <li>A description of the issue</li>
            <li>Clear photo evidence of the defect or damage</li>
            <li>Photos of the packaging (if applicable)</li>
          </ul>
        </div>

        <div className="policy-section">
          <h3>Claim Review Process</h3>
          <p>
            Once your claim is reviewed and approved, we will provide instructions for a replacement or appropriate resolution at our discretion. We reserve the right to deny claims that:
          </p>
          <ul>
            <li>Are submitted after 7 days of delivery</li>
            <li>Show signs of wear, misuse, or damage not caused during manufacturing or shipping</li>
            <li>Lack sufficient photo proof</li>
          </ul>
        </div>

        <div className="policy-section">
          <h3>Contact Us</h3>
          <p>
            If you have any questions, please{' '}
            <button className="policy-contact-link" onClick={handleContactClick}>
              contact us here
            </button>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ReturnPolicyModal;
